import script from "./LabelComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LabelComponent.vue?vue&type=script&setup=true&lang=ts"

import "./LabelComponent.vue?vue&type=style&index=0&id=6ca18b01&lang=css"

const __exports__ = script;

export default __exports__